import { useEffect, useRef } from 'react'
import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts";
import { Typography } from '@mui/material';
import * as Highchartss from 'highcharts';
import { colors } from '../../constants/colors';
import exporting from 'highcharts/modules/exporting';

exporting(Highcharts)

type Props = {
    className?: string;
    heading: string;
    categories: any[];
    sumAllPaid: any[];
    sumAllBudget: any[];
}

const HorizontalChart = (props: Props) => {
    const chartRef = useRef<any>(null);
    const viewportWidths: number = window.innerWidth;

    // useEffect(() => {
    //     const chart = chartRef.current?.chart;

    //     const setChartSize = () => {
    //         const viewportWidth: number = window.innerWidth;
    //         let newWidth: number = viewportWidth;
    //         let newHeight: number = 300;

    //         if (viewportWidth < 768) {
    //             newWidth = viewportWidth - 50;
    //         }

    //         chart?.setSize(newWidth, newHeight);
    //     };

    //     setChartSize();
    //     window.addEventListener('resize', setChartSize);
    //     return () => window.removeEventListener('resize', setChartSize);
    // }, []);

    const options: Highchartss.Options = {
        chart: {
            type: 'bar',
            width: viewportWidths,
            height: 330,
            spacingBottom: 0,
            marginRight: 10,
        },
        colors: [colors.chart_red, colors.chart_green],
        title: {
            text: '',
            align: 'left'
        },
        subtitle: {
            // enable: false
        },
        xAxis: {
            categories: props.categories || [],
            title: {
                text: null
            },
            gridLineWidth: 1,
            lineWidth: 0
        },
        exporting: {
            // enabled: false,
            buttons: {
                contextButton: {
                    align: 'right',
                    verticalAlign: 'top',
                    x: -30,
                    y: 0
                },
                exportButton: {
                    align: 'left',
                    verticalAlign: 'top',
                    x: 0,
                    y: 0
                }
            }
        },
        yAxis: {
            // min: 0,
            // max: 10,
            title: {
                text: "",
            },
            labels: {
                overflow: 'justify'
            },
            gridLineWidth: 0
        },
        tooltip: {
            valueSuffix: ' บาท',
            positioner: function (boxWidth, boxHeight, point: any) {
                const chart = this.chart;
                let x, y;
                x = (boxWidth / 50) * 100
                y = (boxHeight / 50) * 100

                return { x: x, y: y };
            }
        },
        plotOptions: {
            bar: {
                borderRadius: '0%',
                // spacing: 0,
                pointWidth: 10,
                dataLabels: {
                    enabled: true
                },
                groupPadding: 0.3,
                pointPadding: 4.3,

                legendSymbol: "rectangle",

            }
        },
        legend: {
            layout: 'horizontal',
            align: 'left',
            verticalAlign: 'top',
            x: 0,
            y: 260,
            floating: true,
            // borderWidth: false,
            backgroundColor:
                '#FFFFFF',
            shadow: false,
        },
        credits: {
            enabled: false,

        },
        series: [
            {
                type: 'bar',
                name: 'เบิกจ่าย',
                data: props.sumAllPaid || []
            },
            {
                type: 'bar',
                name: 'งบประมาณ',
                data: props.sumAllBudget || []
            }
        ],
        responsive: {
            rules: [{
                condition: {
                    maxWidth: 500
                },
                chartOptions: {
                    legend: {
                        align: 'center',
                        verticalAlign: 'bottom',
                        layout: 'horizontal'
                    }
                }
            }]
        }
    }


    const testOption = {
        chart: {
            type: 'bar'  // Change this to 'bar'
        },
        colors: [colors.chart_red, colors.chart_green],
        title: {
            text: '',
            align: 'left',
            enabled: false
        },
        xAxis: {
            categories: props.categories || [],
            title: {
                text: null
            },
            gridLineWidth: 1,
            lineWidth: 0
        },
        yAxis: {
            min: 0,
            gridLineWidth: 0,
            title: {
                text: ''
            }
        },
        credits: {
            enabled: false,

        },
        tooltip: {
            valueSuffix: ' บาท'
        },
        plotOptions: {
            bar: {
                pointPadding: 0.2,
                borderWidth: 0
            }
        },
        series: [
            {
                type: 'bar',
                name: 'เบิกจ่าย',
                data: props.sumAllPaid || []
            },
            {
                type: 'bar',
                name: 'งบประมาณ',
                data: props.sumAllBudget || []
            }
        ],
    }

    return (
        <section className={`shadow-sm rounded-xl border-[1px] border-light ${props.className}`}>
            <span className='p-3 flex justify-between items-center border-[1px] rounded-t-xl border-[#E5E5E7]'>
                <Typography variant='h6'>
                    {props.heading}
                </Typography>
                {/* <Button sx={{ borderRadius: "10px" }} startIcon={<img src={RouteImage.dropdownDot} />}>

                </Button> */}
            </span>
            <article className='w-full flex justify-center flex-col items-center h-full'>
                <HighchartsReact
                    ref={chartRef}
                    containerProps={{ style: { height: "auto", width: "100%" } }}
                    highcharts={Highcharts}
                    options={testOption}
                />
            </article>
        </section>
    )
}

export default HorizontalChart